module.exports = __webpack_public_path__ + "img/PLAYBARBISH.706c1392.png";